import { Box, Button, Switch } from "@mui/material";
import { Link } from "react-router-dom";
import { PRIVATE_PAGES } from "@app/router/pages";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { VisibleEnum } from "types";
import { EXTRA_DATE_FORMAT } from "@constants/index";
import BasicPagination from "@app/components/Pagination";
import { format } from 'date-fns';

import { StyledTableCell } from "./styled";
import { useBlogsLogic } from "./useBlogsLogic";

const Blogs = () => {
  const {
    blogsList,
    pagesCount,
    handleChange,
    handleDeleteBlog,
    handlePagination
  } = useBlogsLogic()

  return (
    <Box
      sx={{
        display: 'flex',
        gap: '20px',
        flexDirection: 'column',
        alignItems: 'flex-end'
      }}
    >
      <Link to={PRIVATE_PAGES.CREATE_BLOGS}>
        <Button variant="contained" color="primary">
          Create Blog
        </Button>
      </Link>

      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell align="center">TITLE AM</TableCell>
              <TableCell align="center">TITLE En</TableCell>
              <TableCell align="center">TITLE Ru</TableCell>
              <TableCell align="center">READ TIME</TableCell>
              <TableCell align="center">POSTED DATE</TableCell>
              <TableCell align="center">VISIBALITY</TableCell>
              <TableCell align="center">IN HOME</TableCell>
              <TableCell align="center">ACTIONS</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {blogsList.map((blog) => {
              return (
                <TableRow key={blog.id}>
                  <TableCell align="center">{blog.titleAm}</TableCell>
                  <TableCell align="center">{blog.titleEn}</TableCell>
                  <TableCell align="center">{blog.titleRu}</TableCell>
                  <TableCell align="center">
                    {blog.minRead}
                    m
                  </TableCell>
                  <TableCell align="center">{format(new Date(blog.postedDate), EXTRA_DATE_FORMAT)}</TableCell>
                  <TableCell align="center">{blog.visible ? VisibleEnum.YES : VisibleEnum.NO}</TableCell>
                  <TableCell>
                    <Switch
                      checked={blog.activeInHome}
                      onChange={() => handleChange(blog)}
                    />
                  </TableCell>
                  <StyledTableCell align="center">
                    <Link to={`/blog/${blog.id}`}>
                      <Button variant="outlined">
                        Edit
                      </Button>
                    </Link>
                    <Button
                      variant="contained"
                      onClick={() => handleDeleteBlog(blog.id)}
                    >
                      Delete
                    </Button>
                  </StyledTableCell>
                </TableRow>
              )
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <BasicPagination count={pagesCount} callback={handlePagination} />
    </Box>
  )
};

export default Blogs;
